import PropTypes from "prop-types";
import * as React from "react";
import { UploadTray } from "../../../themeV2";

const IN_FLIGHT = new Set(["preparing", "uploading"]);

const UploadStatus = function UploadStatus({ cards }) {
  const items = cards.flatMap((card) =>
    card.images
      .filter((image) => IN_FLIGHT.has(image.status))
      .map((image) => ({
        id: image.imageId,
        title: card.name || image.fileName || "Image",
        subtitle: image.status === "preparing" ? "Preparing" : "Uploading",
        thumbnail: <img src={image.previewUrl} alt="" width="40" height="40" />,
        percent: image.percent ?? undefined,
      })),
  );
  const reported = items.filter((item) => item.percent !== undefined);

  return (
    <UploadTray
      items={items}
      summary={{
        label: `Uploading ${items.length} image${
          items.length === 1 ? "" : "s"
        }`,
        percent:
          reported.length > 0
            ? Math.round(
                reported.reduce((sum, item) => sum + item.percent, 0) /
                  reported.length,
              )
            : undefined,
      }}
    />
  );
};

UploadStatus.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default UploadStatus;
